import styled from 'styled-components';
import Field from '@widgets/shared/components/NumberInput/styles/field';
import Input from '@widgets/shared/components/NumberInput/styles/control';
import Band from '@genericBookings/components/AttendeesSelector/components/Band/styles';
export const Wrapper = styled.div `
  
`;
export const BandsList = styled.ul `
  display: block;
  list-style: none;
  margin: 0 0 1.5rem;
  background-color: white;
  padding: 1.5rem;
  border: 0.1rem solid var(--border);
  border-radius: var(--border-radius-sm);
  
  ${Band.Item} {
    align-items: center;
  }
  
  ${Band.Name} {
    font-weight: 600;
  }
  
  ${Band.Note} {
    font: var(--paragraph-medium-font);
    color: var(--text);
    margin-top: 0;
  }
  
  ${Field.Price} {
    display: none;
  }
  
  ${Field.Wrapper} {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex: 0 1 0;
    align-items: center;
    
    ${Input.Element} {
      font: var(--heading-six-font);
      font-weight: 600;
      margin-bottom: 0;
      color: var(--primary-darker);
    }
  }
`;
export default {
    Wrapper,
};
